import { lazy, Suspense } from 'react';

import { ListSkeleton } from '@/shared/components/skeletons';
import { Skeleton } from '@/shared/ui/skeleton';

/* The card of an item loads on demand; this wrapper is what the registry renders. */

const ItemPanel = lazy(() => import('./components/ItemPanel'));

function PanelFallback() {
  return (
    <div className="space-y-4 p-6" aria-busy>
      <Skeleton className="h-6 w-2/3" />
      <Skeleton className="h-4 w-40" />
      <ListSkeleton rows={4} avatar={false} />
    </div>
  );
}

export function LazyItemPanel({ id }: { id: string }) {
  return (
    <Suspense fallback={<PanelFallback />}>
      <ItemPanel key={id} id={id} />
    </Suspense>
  );
}

/* The «Process» tab of the feed's composer (`feedComposerTabs`) loads when somebody opens it. */

const ProcessComposerTab = lazy(() => import('./components/ProcessComposerTab'));

export function LazyProcessComposerTab({ onDone }: { onDone: () => void }) {
  return (
    <Suspense fallback={<ListSkeleton rows={3} avatar={false} />}>
      <ProcessComposerTab onDone={onDone} />
    </Suspense>
  );
}
